import { render } from "./Xinxi.vue?vue&type=template&id=6c07e49e&scoped=true"
import script from "./Xinxi.vue?vue&type=script&lang=js"
export * from "./Xinxi.vue?vue&type=script&lang=js"

import "./Xinxi.vue?vue&type=style&index=0&id=6c07e49e&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c07e49e"]])

export default __exports__